import { incYenOf } from '../../../lib/pricing';
const coursesEssential = {
  // page.tsx JSON-LD
  'coursesEssential.jsonld.breadcrumb.home': 'ホーム',
  'coursesEssential.jsonld.breadcrumb.courses': 'コース紹介',
  'coursesEssential.jsonld.breadcrumb.current': 'エッセンシャルコース',
  'coursesEssential.jsonld.course.name': 'エッセンシャルコース',
  'coursesEssential.jsonld.course.description': '執事に必要な基礎技能と心構えを1ヶ月・48時間で体系的に習得する入門課程。全日本執事協会運営。',
  'coursesEssential.jsonld.provider': '一般社団法人全日本執事協会',
  'coursesEssential.lastUpdated': '最終更新: 2026年6月13日',
  'coursesEssential.backToTop': 'ページトップへ戻る',

  // HeroSection
  'coursesEssential.hero.homeLink': 'ホーム',
  'coursesEssential.hero.coursesLink': 'コース紹介',
  'coursesEssential.hero.currentPage': 'エッセンシャルコース',
  'coursesEssential.hero.title': 'エッセンシャルコース',
  'coursesEssential.hero.titleEn': 'ESSENTIAL COURSE',
  'coursesEssential.hero.lead': 'エッセンシャルコースは、執事に必要な基礎技能と心構えを1ヶ月・48時間で体系的に習得する入門課程です。執事の技能を基礎から学べる執事学校の入門として、未経験から執事養成の第一歩を踏み出せます。',
  'coursesEssential.hero.imgAlt': '白手袋で銀のトレイを丁寧に磨く日本人男性執事 - エッセンシャルコース',
  'coursesEssential.hero.imgTitle': '日本執事アカデミー エッセンシャルコース',

  // CourseOverview
  'coursesEssential.overview.label': 'COURSE OVERVIEW',
  'coursesEssential.overview.title': 'コース概要',
  'coursesEssential.overview.colItem': '項目',
  'coursesEssential.overview.colContent': '内容',
  'coursesEssential.overview.rowDuration': '期間',
  'coursesEssential.overview.rowDays': '開催日数',
  'coursesEssential.overview.rowHours': '総時間',
  'coursesEssential.overview.rowPrice': '受講料',
  'coursesEssential.overview.rowSchedule': '開校時期',
  'coursesEssential.overview.rowFormat': '授業形式',
  'coursesEssential.overview.rowCapacity': '定員',
  'coursesEssential.overview.rowTarget': '対象',
  'coursesEssential.overview.priceFormat': '¥{price}（税込）',
  'coursesEssential.overview.note': '※表示価格はすべて税込です。開校日程の詳細は',
  'coursesEssential.overview.scheduleLink': '年間スケジュール',
  'coursesEssential.overview.noteSuffix': 'をご確認ください。',

  // TargetAudience
  'coursesEssential.target.label': 'WHO IS THIS FOR',
  'coursesEssential.target.title': 'こんな方におすすめ',
  'coursesEssential.target.lead': 'エッセンシャルコースは、以下のような方を対象に設計されています',

  // LearningContent
  'coursesEssential.learning.label': 'CURRICULUM',
  'coursesEssential.learning.title': 'エッセンシャルコースで何が学べる？',
  'coursesEssential.learning.lead': '基礎の所作から実践的なサービススキルまで、6つの領域を体系的に学びます。日本の執事学校における執事養成の入門段階として、約1ヶ月（8日間・48時間）で基礎を固め、学費はコース概要の受講料欄をご確認ください。',
  'coursesEssential.learning.imgAlt': 'エッセンシャルコース学習内容 - {title}の実習風景',
  'coursesEssential.learning.imgTitle': '日本執事アカデミー - {title}',

  // LearningProgression
  'coursesEssential.progression.label': 'LEARNING FLOW',
  'coursesEssential.progression.title': '学習の流れ',
  'coursesEssential.progression.lead': '全8日間を通じて、以下の順で基礎から段階的に習得します',
  'coursesEssential.progression.0.title': '前半（Day1〜4）',
  'coursesEssential.progression.0.description': '基本マナーとエチケット → 日常的な家事管理 → 基本的なテーブルセッティングの順に、執事の土台となる所作を固めます。',
  'coursesEssential.progression.1.title': '後半（Day5〜8）',
  'coursesEssential.progression.1.description': '紅茶とコーヒーの淹れ方 → 衣類の手入れ → 基本的なコミュニケーション技術の順に学び、日常的なサービスを単独で行えるレベルへ仕上げます。',
  'coursesEssential.progression.note': '※上記は代表的な学習順序です。実際の進行は開校回により多少前後する場合があります。',

  // DailySchedule
  'coursesEssential.schedule.label': 'DAILY SCHEDULE',
  'coursesEssential.schedule.title': '1日の流れ',
  'coursesEssential.schedule.lead': '90分×4コマで構成される授業日（土曜または日曜）のタイムテーブル例です',
  'coursesEssential.schedule.note': '※上記は標準的なタイムテーブル例です。回により内容が前後する場合がございます。',

  // CertificationSection
  'coursesEssential.cert.label': 'CERTIFICATION',
  'coursesEssential.cert.title': '修了実技試験と認定資格',
  'coursesEssential.cert.qualLabel': '取得資格',

  // CourseBenefits
  'coursesEssential.benefits.label': 'BENEFITS',
  'coursesEssential.benefits.title': '受講特典',
  'coursesEssential.benefits.lead': 'エッセンシャルコース受講生の皆様に付帯する特典です',
  'coursesEssential.benefits.detailLink': '※特典の詳細は受講特典ページをご覧ください',

  // NextStep
  'coursesEssential.nextStep.label': 'NEXT STEP',
  'coursesEssential.nextStep.discountLabel': '減額: ¥{amount}',
  'coursesEssential.nextStep.viewAdvanced': 'アドバンスコースを見る',

  // AdmissionFlow
  'coursesEssential.admission.label': 'ADMISSION FLOW',
  'coursesEssential.admission.title': '受講までの流れ',
  'coursesEssential.admission.viewDetail': '詳細を見る',

  // CTASection
  'coursesEssential.cta.label': 'TAKE THE FIRST STEP',
  'coursesEssential.cta.title': 'まずは資料請求から',
  'coursesEssential.cta.lead': '無料の資料でコースの詳細やアカデミーの理念をじっくりご確認いただけます。ご不明な点は個別相談（オンライン対応可）にてお気軽におたずねください。',
  'coursesEssential.cta.brochure': '資料請求はこちら（無料）',
  'coursesEssential.cta.consultation': '個別相談を予約する',
  'coursesEssential.cta.note': '※ご相談はオンラインでも承ります',
  'coursesEssential.cta.seminarLink': 'まずは1日、執事の世界を体験する',

  // RelatedPages
  'coursesEssential.related.label': 'RELATED',
  'coursesEssential.related.title': '関連ページ',
  'coursesEssential.related.viewDetail': '詳しく見る',

  // FAQSection
  'coursesEssential.faq.label': 'FAQ',
  'coursesEssential.faq.title': 'よくあるご質問',

  // trustBadges (mock data text)
  'coursesEssential.badge.0': '定員6名の完全少人数制',
  'coursesEssential.badge.1': '土日開催・働きながら学べる',
  'coursesEssential.badge.2': '修了で協会認定資格',

  // courseOverview fields
  'coursesEssential.overview.duration': '1ヶ月',
  'coursesEssential.overview.days': '8日間',
  'coursesEssential.overview.totalHours': '48時間',
  'coursesEssential.overview.price': incYenOf('ac-essential'),
  'coursesEssential.overview.schedule': '7月・1月開校',
  'coursesEssential.overview.classFormat': '土日開催・1日6時間（90分×4コマ）',
  'coursesEssential.overview.capacity': '完全少人数制（定員6名）',
  'coursesEssential.overview.target': '初心者・キャリアチェンジ希望者',

  // targetAudienceItems
  'coursesEssential.target.0': '執事として新たなキャリアを始めたい方',
  'coursesEssential.target.1': '接客・サービス業から専門性を高めたい方',
  'coursesEssential.target.2': '家庭や職場で本物のおもてなしを身につけたい方',
  'coursesEssential.target.3': 'マスターコースへの段階的なステップを望む方',

  // learningContents
  'coursesEssential.learning.0.title': '基本マナーとエチケット',
  'coursesEssential.learning.0.titleEn': 'Manners & Etiquette',
  'coursesEssential.learning.0.description': '挨拶・姿勢・歩き方・ドアの開閉・ご案内の所作など、執事の全業務の土台となる立ち居振る舞いを習得します。鏡を使った自己チェックと講師による個別指導で、自然で品格ある所作が身につきます。お辞儀は、上体を約15度傾ける会釈、約30度傾ける普通礼、約45度傾ける敬礼の三つを、相手や場面に応じて使い分けられるよう反復します。日常の業務で最も多く使うのは普通礼であり、丁寧なお辞儀では言葉を伝えてから礼に移る順番と、腰から上体を倒して一呼吸置き、ゆっくりともとの姿勢へ戻る速度までを整えます。',
  'coursesEssential.learning.1.title': '日常的な家事管理',
  'coursesEssential.learning.1.titleEn': 'Household Management',
  'coursesEssential.learning.1.description': '清掃と整理整頓の段取り、買い物と在庫の管理など、家政を「こなす」のではなく「管理する」視点を学びます。チェックリストを用いた効率的な巡回管理の手法を実践的に習得します。',
  'coursesEssential.learning.2.title': '基本的なテーブルセッティング',
  'coursesEssential.learning.2.titleEn': 'Table Setting',
  'coursesEssential.learning.2.description': 'カトラリーとグラスの正しい配置、ナプキンの扱い方を学びます。朝食からディナーまでの基本形を実物の食器を用いて繰り返し練習し、どんな場面でも美しいテーブルを整えられるようになります。',
  'coursesEssential.learning.3.title': '紅茶とコーヒーの淹れ方',
  'coursesEssential.learning.3.titleEn': 'Tea & Coffee Service',
  'coursesEssential.learning.3.description': '茶葉と豆の基礎知識、温度と時間の管理、美しい注ぎ方と提供の所作を体系的に学びます。テイスティング演習を通じて味覚も鍛え、受講生の皆様が自信を持ってサービスできる水準を目指します。紅茶は、ポットとカップをあらかじめ温めたうえで、1人当たり3gの茶葉を量り、汲みたての水を沸騰させた熱湯を注いでふたをし、3分を基準に蒸らすという手順を基本形として身につけます（茶葉の量や蒸らし時間は商品によって異なります）。\n\n注ぐときはポットの取っ手を右手でしっかりと持ち、カップから5〜10cmほどの高さを保って、ポットがぶつからないよう注意しながら7〜8分目まで静かに注ぎ、注ぎ終わったらしずくが垂れないようポットの口先を軽く上げます。注いだあとは「ミルクはいかがですか」「お砂糖はお使いになりますか」と確認します。好みを把握している場合でも、その日の気分で変わることがあるため、ひと言添えるのがマナーです。\n\nおかわりは、カップの紅茶が4分の1ほどになったタイミングで、完全に空になってしまう前を目安にお伺いし、「おかわりをお注ぎいたしましょうか」「もう一杯いかがでございますか」と声をかけます。ポットの紅茶が濃くなりすぎている場合は、淹れ直すことを提案するという判断まで含めて練習します。',
  'coursesEssential.learning.4.title': '衣類の手入れ',
  'coursesEssential.learning.4.titleEn': 'Garment Care',
  'coursesEssential.learning.4.description': 'シャツのアイロンがけ、ブラッシング、保管の基本を実習中心で学びます。生地の種類に応じた適切な温度管理と、美しい仕上げのコツを習得し、衣類を長く最良の状態で保つ技術が身につきます。',
  'coursesEssential.learning.5.title': '基本的なコミュニケーション技術',
  'coursesEssential.learning.5.titleEn': 'Communication Skills',
  'coursesEssential.learning.5.description': '品格ある言葉遣い、適切な距離感の取り方、報告・連絡・相談の作法をロールプレイング形式で学びます。相手に安心感と信頼感を与えるコミュニケーションの基礎を、実践的な演習を通じて習得します。',

  // dailySchedule
  'coursesEssential.schedule.0.time': '10:00 – 11:30',
  'coursesEssential.schedule.0.title': '理論講義',
  'coursesEssential.schedule.0.description': '各回のテーマに沿った座学。教科書と映像教材を用いて基礎知識を体系的に学びます。',
  'coursesEssential.schedule.1.time': '11:45 – 13:15',
  'coursesEssential.schedule.1.title': '実技演習',
  'coursesEssential.schedule.1.description': '講師のデモンストレーションの後、受講生お一人ずつ実践。少人数制のため丁寧な個別指導が受けられます。',
  'coursesEssential.schedule.2.time': '13:15 – 14:00',
  'coursesEssential.schedule.2.title': '昼食休憩',
  'coursesEssential.schedule.2.description': '',
  'coursesEssential.schedule.3.time': '14:00 – 15:30',
  'coursesEssential.schedule.3.title': 'ロールプレイング実習',
  'coursesEssential.schedule.3.description': '実際の邸宅やホテルを想定したシチュエーション演習。受講生同士で執事役と依頼者役を交互に体験します。',
  'coursesEssential.schedule.4.time': '15:45 – 17:15',
  'coursesEssential.schedule.4.title': '実技＋振り返り',
  'coursesEssential.schedule.4.description': '午前の実技の応用演習と、その日の学びを講師とともに振り返るレビューセッション。質疑応答の時間も設けています。',

  // certificationInfo
  'coursesEssential.cert.description': 'コース最終日に実施する修了実技試験（テーブルセッティングとティーサービスの実演）に合格すると、以下の認定資格が授与されます。',
  'coursesEssential.cert.qualification': '認定アソシエイトバトラー（Certified Associate Butler）',
  'coursesEssential.cert.badge': '認定ピンバッジ',
  'coursesEssential.cert.note': '※当資格は一般社団法人全日本執事協会が独自に認定する民間資格です。',
  'coursesEssential.cert.titleEn': 'Certification Exam',

  // courseBenefits
  'coursesEssential.benefits.0.title': '基本的な執事道具セット',
  'coursesEssential.benefits.0.description': 'プロ仕様の基本ツール一式を進呈します。',
  'coursesEssential.benefits.1.title': '教科書セット（全5冊・E1〜E5）',
  'coursesEssential.benefits.1.description': '全日本執事協会監修。「執事学入門」から「英国紳士の教養とたしなみ」までE群5冊を進呈。修了後も参照できる充実のセットです。',
  'coursesEssential.benefits.2.title': 'オリジナルエプロン',
  'coursesEssential.benefits.2.description': '実習時に着用するアカデミー特製のエプロン。',
  'coursesEssential.benefits.3.title': '白手袋（初日支給・実習で着用）',
  'coursesEssential.benefits.3.description': '高品質な白手袋。執事の象徴として、初日からサービス実習で着用します。',

  // nextStep
  'coursesEssential.nextStep.title': '次のステップ — アドバンスコースへの編入優遇',
  'coursesEssential.nextStep.description': 'エッセンシャルコース修了者がアドバンスコースへ進む場合、受講料から80,000円が減額されます。基礎を固めた後は、より高度なワインサービスやイベント運営へと領域を広げてまいりましょう。',
  'coursesEssential.nextStep.discountAmount': '80,000',

  // admissionSteps
  'coursesEssential.admission.0.title': '資料請求',
  'coursesEssential.admission.0.titleEn': 'Brochure',
  'coursesEssential.admission.0.description': 'まずは資料請求から。コースの詳細やアカデミーの理念をまとめた資料をお送りします。',
  'coursesEssential.admission.1.title': '個別相談（任意）',
  'coursesEssential.admission.1.titleEn': 'Consultation',
  'coursesEssential.admission.1.description': '経験豊富なスタッフが、あなたの目標やご経験に合わせた最適なコース選びをサポートします。',
  'coursesEssential.admission.2.title': 'お申込み',
  'coursesEssential.admission.2.titleEn': 'Apply',
  'coursesEssential.admission.2.description': 'コースが決まりましたら、所定の申込フォームよりお手続きください。定員になり次第締切となります。',
  'coursesEssential.admission.3.title': '受講確定',
  'coursesEssential.admission.3.titleEn': 'Confirmation',
  'coursesEssential.admission.3.description': 'お申込み受付後、受講確定のご案内と事前準備資料をお送りします。開校日をお待ちください。',

  // relatedPages
  'coursesEssential.related.0.title': 'アドバンスコース',
  'coursesEssential.related.0.description': 'ワインと宴会運営へ進む中級課程',
  'coursesEssential.related.1.title': 'マスターコース',
  'coursesEssential.related.1.description': 'プロを目指す最上級課程',
  'coursesEssential.related.2.title': 'コース比較',
  'coursesEssential.related.2.description': '3コースの違いを一覧で確認',
  'coursesEssential.related.3.title': '年間スケジュール',
  'coursesEssential.related.3.description': '開校時期と授業日程のご案内',
  'coursesEssential.related.4.title': '料金詳細',
  'coursesEssential.related.4.description': '受講料に含まれるものの内訳',
  'coursesEssential.related.5.title': 'カリキュラム',
  'coursesEssential.related.5.description': '学ぶ内容の全体像を確認',

  // faqItems
  'coursesEssential.faq.0.question': '未経験でも受講できますか？',
  'coursesEssential.faq.0.answer': 'はい。エッセンシャルコースは初心者の方を前提に設計されており、受講資格は18歳以上・経験不問です。基礎の所作から段階的に学べますのでご安心ください。',
  'coursesEssential.faq.1.question': '服装の指定はありますか？',
  'coursesEssential.faq.1.answer': '授業日は白シャツ・黒系のスラックスまたはスカート・革靴をお願いしています。白手袋は初日に当アカデミーからお渡しします。詳細はお申込み後にご案内いたします。',
  'coursesEssential.faq.2.question': '支払い方法を教えてください。',
  'coursesEssential.faq.2.answer': '銀行振込による一括払いのみとなります。分割払い・クレジットカードはご利用いただけません。お支払い期限は開校日の14日前です。',
  'coursesEssential.faq.3.question': '欠席した場合はどうなりますか？',
  'coursesEssential.faq.3.answer': '修了には出席率80%以上が必要です。やむを得ず欠席される場合の対応は、状況に応じて個別にご相談を承りますので、事務局までお問い合わせください。予習・復習用のオンデマンド動画もご活用いただけます。',
  'coursesEssential.faq.4.question': '修了するとどんな資格が得られますか？',
  'coursesEssential.faq.4.answer': '修了時の実技試験（テーブルセッティング等）に合格すると、一般社団法人全日本執事協会が認定する民間資格「認定アソシエイトバトラー」と認定ピンバッジを授与します。国家資格ではなく、協会が認定する資格です。',
  'coursesEssential.faq.5.question': '定員と開催形式を教えてください。',
  'coursesEssential.faq.5.answer': '1クラス最大6名の少人数制（最少催行3名）です。お台場の校舎で土日に開催し、1日6時間（90分×4コマ）の対面授業を行います。予習・復習にはオンデマンド動画を併用します。',
};

export default coursesEssential;
